import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { IconClock } from '../icons';

// Часы в навигации показывают время СЕРВЕРА, а не браузера: проверки по
// расписанию и история аптайма идут по серверным часам, и когда у человека
// сбиты часы или он в другом поясе, сопоставить «когда упало» становится
// расследованием. Тот же компонент, что в навбаре аналитики.
//
// Механика: один раз спрашиваем /health (он и так отдаёт timestamp и не
// требует токена), запоминаем разницу с локальными часами и дальше тикаем
// сами. Секундный опрос сервера был бы 86 400 запросов в день на вкладку ради
// величины, которая меняется предсказуемо.
const SYNC_INTERVAL = 5 * 60 * 1000;

const pad = (value) => String(value).padStart(2, '0');

// 10.09 · 09:11:33 по UTC. Через getUTC*, а не toLocaleString с timeZone:
// формат один на всех пользователей и не зависит от локали браузера.
const formatUtc = (date) => {
  const day = `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}`;
  const time = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
  return `${day} · ${time}`;
};

const ServerClock = ({ className = '' }) => {
  // Разница «серверное минус локальное». null — ещё не синхронизировались:
  // до первого ответа показывать локальное время нельзя, подпись обещает
  // серверное.
  const offsetRef = useRef(null);
  const [text, setText] = useState(null);

  useEffect(() => {
    let alive = true;

    const sync = async () => {
      try {
        const { data } = await axios.get('/health');
        if (!alive || !data?.timestamp) return;
        offsetRef.current = new Date(data.timestamp).getTime() - Date.now();
      }
      catch {
        // Сервер недоступен — часы просто не появятся (или замрут на
        // последнем известном смещении). Ронять навигацию из-за них незачем.
      }
    };

    const tick = () => {
      if (!alive || offsetRef.current === null) return;
      setText(formatUtc(new Date(Date.now() + offsetRef.current)));
    };

    sync().then(tick);
    const ticker = setInterval(tick, 1000);
    const syncer = setInterval(() => { sync().then(tick); }, SYNC_INTERVAL);

    return () => {
      alive = false;
      clearInterval(ticker);
      clearInterval(syncer);
    };
  }, []);

  if (!text) return null;

  return (
    <div className={`flex items-center gap-2 text-white ${className}`}>
      <IconClock size={16} className="shrink-0 opacity-70" />
      <div className="leading-none">
        {/* Без opacity: мелкая белая подпись по nav-bg и так близко к порогу
            4.5:1, любая альфа роняет её ниже. Вторичность несут размер и
            разрядка, а не прозрачность. У иконки opacity осталась: для
            графики порог 3:1, и он проходит. */}
        <div className="text-[11px] leading-[12px] font-semibold tracking-[0.08em]">
          SERVER · UTC
        </div>
        <div className="text-sm leading-4 font-mono tabular-nums mt-1">{text}</div>
      </div>
    </div>
  );
};

export default ServerClock;
